import { useTranslation } from 'react-i18next';
import { useClassroomCapabilities } from '../../hooks/use-classroom-capabilities';
import type { Classroom } from '../../modules/classroom';
import { ClassCard } from '../class-card';
import { useClassroomCreateOptions } from './hooks/use-classroom-create-options';

type MyClassesClassCardProps = {
  classroom: Classroom;
  index: number;
  onClick: () => void;
  onOpenOptions: () => void;
  openEditModal: (classroom: Classroom) => void;
  onLeaveClassWithConfirmation: (classroom: Classroom) => void;
  onDeleteClassWithConfirmation: (classroom: Classroom) => void;
};

export function MyClassesClassCard({
  classroom,
  index,
  onClick,
  onOpenOptions,
  openEditModal,
  onLeaveClassWithConfirmation,
  onDeleteClassWithConfirmation,
}: MyClassesClassCardProps): JSX.Element {
  const { t } = useTranslation();
  const {
    classroom: { shouldShowAlias },
  } = useClassroomCapabilities({ classroom });

  const { options } = useClassroomCreateOptions({
    classroom,
    openEditModal,
    onLeaveClassWithConfirmation,
    onDeleteClassWithConfirmation,
  });

  const getTitle = () => {
    return shouldShowAlias ? classroom.alias : classroom.name;
  };

  const getSubtitle = () => {
    return classroom?.courseName;
  };

  const getTitleTooltip = () => {
    return shouldShowAlias ? classroom.name : undefined;
  };

  return (
    <ClassCard
      title={getTitle()}
      subtitle={getSubtitle()}
      titleTooltip={getTitleTooltip()}
      key={`${classroom.name}-${index}`}
      onClick={onClick}
      onOpenOptions={onOpenOptions}
      options={options}
      classroom={classroom}
    />
  );
}
